<template>
  <div>
    <GlobalHead @updateGroup="getGroupList" />
    <div class="banner">
      <div>
        {{
          [
            '权责清单',
            '公共服务清单',
            '跑零次清单',
            '最多跑一次清单',
            '联办事项清单',
            '通办事项清单',
            '马上办事项清单'
          ][type]
        }}
      </div>
    </div>
    <div class="layout">
      <div class="sider">
        <div class="line"></div>
        <div class="tabs">
          <div
            :class="tabFlag && 'selected'"
            @click="
              tabFlag = true
              getMightrList()
            "
          >
            <img :src="require(`@/assets/jiopweb/group${tabFlag ? '_selected' : ''}.png`)" alt="" />
            <span>按部门</span>
          </div>
          <div
            v-if="type === '0'"
            :class="!tabFlag && 'selected'"
            @click="
              tabFlag = false
              getMightrList()
            "
          >
            <img
              :src="require(`@/assets/jiopweb/matter${!tabFlag ? '_selected' : ''}.png`)"
              alt=""
            />
            <span>按类型</span>
          </div>
        </div>
        <div style="flex: 1; overflow-y: auto">
          <div
            :class="[
              'menu',
              ((tabFlag && selectedGroup === index) || (!tabFlag && selectedMatter === index)) &&
                'selected'
            ]"
            v-for="({ name, iid }, index) in menuList"
            :key="iid"
            @click="
              tabFlag ? (selectedGroup = index) : (selectedMatter = index)
              getMightrList()
            "
          >
            <a-tooltip placement="left">
              <template slot="title">
                {{ name }}
              </template>
              <div>{{ name }}</div>
            </a-tooltip>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="top">
          <span>共 {{ pagination.total }} 件事项</span>
          <h-search
            v-model="searchText"
            placeholder="请输入事项名称检索"
            @clean="getMightrList"
            @search="getMightrList"
            :style="{ width: '260px' }"
          />
        </div>
        <div class="header">
          <span class="name">事项名称</span>
          <span class="action">操作</span>
        </div>
        <a-spin :spinning="spinning">
          <div v-show="spinning" style="height: 100px" />
        </a-spin>
        <a-empty v-show="!list.length && !spinning" style="margin: 50px auto" />
        <div style="flex: 1; overflow-y: auto">
          <div class="list_item" v-for="item in list" :key="item.iid">
            <div class="col">
              <div class="left">
                <span class="icon"></span>
                <span
                  :style="{ cursor: item.isLeaf ? 'pointer' : undefined }"
                  @click="toGuide(item)"
                >
                  {{ item.name }}
                </span>
                <div class="button" v-if="!item.isLeaf" @click="item.show = !item.show">
                  <span>{{ item.children.length }}项</span>
                  <img
                    src="@/assets/jiopweb/arrow.png"
                    alt=""
                    :style="{ transform: item.show ? 'scaleY(-1)' : undefined }"
                  />
                </div>
              </div>
              <div class="right" v-if="item.isLeaf">
                <span :class="[item.disabled && 'disabled']" @click="handleProcess(item)">
                  在线办理
                </span>
              </div>
            </div>
            <div v-for="item1 in item.children" :key="item1.iid" v-show="item.show">
              <div :class="['col', 'col1', item1.isLeaf && 'col2']">
                <div class="left" style="margin-left: 59px">
                  <span @click="toGuide(item1)">
                    {{ item1.name }}
                  </span>
                  <div class="button" v-if="!item1.isLeaf" @click="item1.show = !item1.show">
                    <span>{{ item1.children.length }}项</span>
                    <img
                      src="@/assets/jiopweb/arrow.png"
                      alt=""
                      :style="{ transform: item1.show ? 'scaleY(-1)' : undefined }"
                    />
                  </div>
                </div>
                <div class="right" v-if="item1.isLeaf">
                  <span :class="[item1.disabled && 'disabled']" @click="handleProcess(item1)">
                    在线办理
                  </span>
                </div>
              </div>
              <div
                :class="['col', 'col1', 'col2']"
                v-for="item2 in item1.children"
                :key="item2.iid"
                v-show="item1.show"
              >
                <div class="left" style="margin-left: 79px">
                  <span @click="toGuide(item2)">{{ item2.name }}</span>
                </div>
                <div class="right">
                  <span :class="[item2.disabled && 'disabled']" @click="handleProcess(item2)">
                    在线办理
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a-pagination
          v-if="pagination.total"
          v-model="pagination.current"
          :total="pagination.total"
          :page-size.sync="pagination.pageSize"
          show-quick-jumper
          :show-total="total => `共有${total}条`"
          @change="getMightrList(true)"
        />
      </div>
    </div>
    <a-modal
      :visible="visible"
      title="提示"
      @ok="
        visible = false
        toLoginPage()
      "
      @cancel="visible = false"
    >
      <a-row style="padding: 8px">
        <a-col :span="2" style="margin-right: 8px">
          <a-icon type="exclamation-circle" style="color: #1890ff; font-size: 22px" />
        </a-col>
        <a-col :span="20">
          <p class="info">您当前尚未登录，是否登录？</p>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal v-model="draftVisible" :footer="null" :closable="false" width="420px">
      <a-row style="padding: 8px">
        <a-col :span="2" style="margin-right: 8px">
          <a-icon type="exclamation-circle" style="color: #1890ff; font-size: 22px" />
        </a-col>
        <a-col :span="20">
          <p class="info">
            您于{{ handling.ctime | timeTransfer }}保存了该事项的草稿，要继续编辑吗？
          </p>
        </a-col>
      </a-row>
      <div style="text-align: right">
        <a-button key="cancel" type="defult" style="margin-right: 5px" @click="routingHop(itemId)">
          重新填报
        </a-button>
        <a-button key="submit" type="primary" @click="refill">继续编辑</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import GlobalHead from '@/views/layout/globalHead.vue'
import HSearch from 'jpaas-component/lib/HSearch'
import { jiopWebAPI } from '@/api/jiopweb/jiopweb'
import { jiopAPI } from '@/api/jiopweb/jiop'
import { axios } from '@/utils/request'
import { sm2 } from 'sm-crypto'
import { timeTransfer } from '@/utils/timeUtil'
export default {
  name: 'ServiceList',
  components: { GlobalHead, HSearch },
  // eslint-disable-next-line vue/require-prop-types
  props: ['type'],
  data () {
    return {
      districtId: sessionStorage.getItem('districtId'),
      tabFlag: true,
      groupList: [],
      matterList: [],
      selectedGroup: 0,
      selectedMatter: 0,
      searchText: '',
      spinning: false,
      list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      visible: false,
      handleType: 'item',
      itemId: '',
      selectType: '',
      itemInfoBean: {},
      serviceObjectName: '',
      reportConfigByIid: {},
      prikey: '5506c31374d5d8e9d79ba5ecc7cd1a7d60df3f7ef5fbb6865ccd9ce489751ac7',
      handling: { ctime: '' },
      metaStyle: {},
      draftVisible: false,
      materialList: []
    }
  },
  filters: {
    timeTransfer
  },
  computed: {
    menuList () {
      return [{ name: '全部', iid: '-1' }].concat(this.tabFlag ? this.groupList : this.matterList)
    }
  },
  methods: {
    getMightrList (flag) {
      this.spinning = true
      if (!flag) {
        this.pagination = {
          current: 1,
          pageSize: 10,
          total: 0
        }
      }
      this.list = []
      jiopWebAPI
        .findMightrList({
          districtId: this.districtId,
          itemTypeIds: this.type === '0' ? 'qzqd' : this.type === '1' ? '20' : undefined,
          ...(this.tabFlag
            ? {
              groupId: this.selectedGroup ? this.menuList[this.selectedGroup].iid : undefined
            }
            : {
              itemTypeIds: this.selectedMatter ? this.menuList[this.selectedMatter].iid : 'qzqd'
            }),
          includeItem: 'yes',
          pageNo: this.pagination.current,
          pageSize: 10,
          itemName: this.searchText,
          taskHandLescope: this.type === '5' ? '02' : undefined,
          taskType: this.type === '6' ? '01' : undefined,
          taskhandleNum: this.type === '2' ? 0 : this.type === '3' ? 1 : undefined
        })
        .then(res => {
          console.log(res, 'res')
          this.spinning = false
          this.pagination.total = res.data.total
          const flag = this.type !== '4'
          this.list = (res.data.matterList || []).map(item => {
            const {
              childItemList: children = [],
              iid,
              itemName,
              taskOnline,
              oneThingId,
              oneThingName
            } = item
            return {
              ...item,
              name: flag ? itemName : oneThingName,
              iid: flag ? iid : oneThingId,
              show: true,
              isLeaf: !children?.length,
              disabled: flag && taskOnline !== 'yes',
              children: children?.map(item => {
                const { childItemList: children = [], iid, itemName: name, taskOnline } = item
                return {
                  ...item,
                  name,
                  iid,
                  show: true,
                  isLeaf: !children?.length,
                  disabled: flag && taskOnline !== 'yes',
                  children: children?.map(item => {
                    const { iid, itemName: name, taskOnline } = item
                    return {
                      ...item,
                      name,
                      iid,
                      isLeaf: true,
                      disabled: flag && taskOnline !== 'yes'
                    }
                  })
                }
              })
            }
          })
        })
    },
    getGroupList (districtId) {
      if (!districtId) return
      this.districtId = districtId
      this.selectedGroup = 0
      this.selectedMatter = 0
      jiopWebAPI.groupList({ districtId }).then(res => {
        this.groupList = res.data.groupList || []
        this.getMightrList()
      })
    },
    toGuide ({ isLeaf, iid: itemId, subjectName, name, guidePcSite }) {
      if (!isLeaf) return
      let url
      if (this.type !== '4') {
        url = this.$router.resolve({
          path: '/guideSimple',
          query: { itemId, areaCode: this.districtId, bannerType: this.$route.query.bannerType }
        })
      } else {
        sessionStorage.setItem('matter_name', name)
        url = this.$router.resolve({
          path: '/oneThingGuide',
          query: { itemId, subjectName }
        })
      }
      if (guidePcSite) {
        window.open(guidePcSite, '_blank')
      } else {
        window.open(url.href, '_blank')
      }
    },
    handleProcess ({ disabled, iid, name, taskServiceObj, taskOnline, taskPcSite }) {
      if (disabled) return
      if (process.env.NODE_ENV === 'development') {
        sessionStorage.setItem(
          'JiopUserInfo',
          JSON.stringify({
            isLogin: true,
            encodeUser:
              '048abb70236750cce60e5fdcfbd6a9313b0e24f46903d65277af11ffe96447a938a122f2dbe8c280b12b4c8d81476f71ddfadc1b2cf769dce1f5ce691bfe880cd70a844b3f05deb8eee0c221dd1d4997cdd5621b07d41f81e0736ff7c86ff610b01823629393059f68a3a1d20331919215dd005b1fa1f2a2ab08ac72712c9332bdac47b824d049cfefe00d9941d6fd2b330dce99613fee237074282efa1132330e677e36bc977dda29803c464305ab9d73fb04a5e5ce04e2aef9b532c6ebebcab65ae8594561ee8a166d89d888a59cf2699e1c777d4fc89dd259ae9de4eb86b9ef16f99d620ebe0d16a49c9ea0146661471f39c56fb03239905d6af15cc987e2747da26af69f58fb5750c08582f3cdbf56ccaa92376858ab204dbceabe2f7a2732aa9bdee461addd5476a81739b439d11f5bb87339073dc9c0688f4ab6917d0b366f14e23405c4dc261b5417f350f40c373b26306a7b13d8a65909bf019a3de6a84ab8',
            desensitizeUser:
              '{"uid":"0220f55db69b4f249e8b69b80afb9d95","userType":1,"name":"*春翔","mobile":"152******89","certType":"居民身份证","certNo":"3****************1","corporationName":null,"creditCode":null,"corUserName":null,"corUserCertType":null,"corUserCertNo":null}',
            accessToken:
              'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTQ0MTg4MTMsImlhdCI6MTY5NDQwMDgxMywidXNlcm5hbWUiOiIwMjIwZjU1ZGI2OWI0ZjI0OWU4YjY5YjgwYWZiOWQ5NSJ9.3tMTDJih83tyBFTKq4xn289VaLHFg8O-5JefwknEJZw;path=/'
            // 'access-token': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTQ0MTg4MTMsImlhdCI6MTY5NDQwMDgxMywidXNlcm5hbWUiOiIwMjIwZjU1ZGI2OWI0ZjI0OWU4YjY5YjgwYWZiOWQ5NSJ9.3tMTDJih83tyBFTKq4xn289VaLHFg8O-5JefwknEJZw'
          })
        )
        document.cookie =
          'accessToken=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTQ0MTg4MTMsImlhdCI6MTY5NDQwMDgxMywidXNlcm5hbWUiOiIwMjIwZjU1ZGI2OWI0ZjI0OWU4YjY5YjgwYWZiOWQ5NSJ9.3tMTDJih83tyBFTKq4xn289VaLHFg8O-5JefwknEJZw;path=/'
        sessionStorage.setItem('JiopSelectItem', 'personal')
        // axios.defaults.headers['access-token'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTQ0MTg4MTMsImlhdCI6MTY5NDQwMDgxMywidXNlcm5hbWUiOiIwMjIwZjU1ZGI2OWI0ZjI0OWU4YjY5YjgwYWZiOWQ5NSJ9.3tMTDJih83tyBFTKq4xn289VaLHFg8O-5JefwknEJZw'
        axios.defaults.headers['accessToken'] =
          'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTQ0MTg4MTMsImlhdCI6MTY5NDQwMDgxMywidXNlcm5hbWUiOiIwMjIwZjU1ZGI2OWI0ZjI0OWU4YjY5YjgwYWZiOWQ5NSJ9.3tMTDJih83tyBFTKq4xn289VaLHFg8O-5JefwknEJZw;path=/'
      }
      this.itemId = iid
      this.selectType = taskServiceObj === '01' ? 'personal' : 'legalperson'
      if (this.identityCheck(name)) {
        // 清空智能填报缓存
        sessionStorage.removeItem(this.itemId + 'SmartFill')
        // 跳转到办事流程
        if (taskPcSite) {
          window.open(taskPcSite, '_blank')
        } else {
          this.getItemBeanSimple(iid, this.type === '4' ? 'onething' : 'item')
        }
      }
    },
    // 校验是否登录，若已登录校验是个人还是法人，未登录去登录
    identityCheck (name) {
      if (sessionStorage.getItem('JiopUserInfo')) {
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        if (userInfo.isLogin) {
          const userParams = JSON.parse(userInfo.desensitizeUser)
          const userType = parseInt(userParams.userType) === 1 ? 'personal' : 'legalperson'
          if (this.selectType !== userType) {
            const type = this.selectType === 'personal' ? '个人' : '法人'
            this.$info({
              title: `该事项仅限${type}账户办理`,
              content: (
                <div>
                  您不是{name}的服务对象
                  <br />
                  请登录{type}账户再来吧
                </div>
              )
            })
            return false
          } else {
            return true
          }
        } else {
          // 是否登录提示框（未登录）
          this.visible = true
          return false
        }
      } else {
        // 是否登录提示框（未登录）
        this.visible = true
        return false
      }
    },
    toLoginPage () {
      jiopWebAPI
        .getLoginUrl({ params: JSON.stringify({ jiopWorkUrl: 'jiopweb' + this.$route.fullPath }) })
        .then(res => {
          if (res.success) {
            if (res.data.url) {
              window.location.href = res.data.url
            }
          }
        })
    },
    // 获取matter数据并存入缓存
    getItemBeanSimple (iid, type) {
      this.handleType = type
      if (type === 'onething') {
        jiopAPI.oneThingGuide({ iid: iid }).then(res => {
          if (res.success) {
            if (res.data.oneThings && res.data.reportConfigByIid) {
              this.itemInfoBean = res.data.oneThings || {}
              this.reportConfigByIid = res.data.reportConfigByIid
              this.findOptionList(
                'materialNecessity,serviceObject,consultationMethod,complaintMethod,materialType,materialForm,sourceChannels',
                type
              )
            }
          }
        })
      } else {
        jiopAPI.findItemBeanSimple({ itemId: iid }).then(res => {
          if (res.success) {
            if (res.data.itemInfoBean && res.data.reportConfigByIid) {
              this.itemInfoBean = res.data.itemInfoBean || {}
              this.reportConfigByIid = res.data.reportConfigByIid
              this.findOptionList(
                'materialNecessity,serviceObject,consultationMethod,complaintMethod,materialType,materialForm,sourceChannels',
                type
              )
            }
          }
        })
      }
    },
    findOptionList (paramter, type) {
      jiopAPI.findOption(Object.assign({ type: paramter })).then(res => {
        if (res.success) {
          if (res.data.data.serviceObject) {
            const objNameList = []
            const serviceObjList = this.itemInfoBean.taskServiceObj
              ? this.itemInfoBean.taskServiceObj.split(',')
              : []
            res.data.data.serviceObject.forEach(val => {
              serviceObjList.forEach(v => {
                if (v === val.dictionaryCode) {
                  objNameList.push(val.name)
                }
              })
            })
            this.serviceObjectName = objNameList.join('、')
            this.setMatterSession(this.itemInfoBean, this.reportConfigByIid, this.itemId, type)
            // 判断是否有草稿
            this.getDraft(this.itemId)
          }
        }
      })
    },
    setMatterSession (itemInfoBean, reportConfigByIid, itemId, type) {
      const obj = {}
      obj.tag = this.serviceObjectName
      obj.groupName = itemInfoBean.deptName
      if (type === 'onething') {
        obj.applyName = itemInfoBean.oneThingName
        obj.matterName = itemInfoBean.oneThingName
      } else {
        obj.applyName = itemInfoBean.itemName
        obj.matterName = itemInfoBean.itemName
      }
      obj.applySource = 'PC'
      obj.matterId = itemInfoBean.iid
      obj.taskCode = itemInfoBean.taskCode
      obj.code = '11'
      obj.flowId = reportConfigByIid.flowId
      obj.metaId = reportConfigByIid.metaId
      const matter = JSON.stringify(obj)
      sessionStorage.setItem(itemId + '_matter', matter)
    },
    getDraft (iid) {
      this.cleanSession()
      const that = this
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
      const userParams = JSON.parse(userInfo.desensitizeUser)
      const userId = userParams.uid
      jiopWebAPI.queryDraft({ userId: userId, matterId: iid }).then(res => {
        if (res.success) {
          if (res.data.draft.handling && res.data.draft.metaStyle) {
            const jsonHandling = sm2.doDecrypt(res.data.draft.handling.substring(2), that.prikey, 1)
            const jsonMetaStyle = sm2.doDecrypt(
              res.data.draft.metaStyle.substring(2),
              that.prikey,
              1
            )
            that.handling = JSON.parse(jsonHandling)
            that.metaStyle = JSON.parse(jsonMetaStyle)
            that.draftVisible = true
            that.materialList = res.data.draft.itemMaterialList || []
          } else {
            that.routingHop(iid)
          }
        }
      })
    },
    // 清除session
    cleanSession () {
      sessionStorage.removeItem(this.itemId + '_listOfSituations')
      sessionStorage.removeItem(this.itemId + '_model')
      sessionStorage.removeItem(this.itemId + '_infoStr')
      sessionStorage.removeItem(this.itemId + '_JiopwebReceive')
      sessionStorage.removeItem(this.itemId + '_JiopwebMaterial')
    },
    routingHop (iid) {
      this.getSteps(iid)
    },
    getSteps (iid) {
      jiopWebAPI.findReportConfigByIid({ itemid: iid }).then(res => {
        const fillingInstruction = res.data.data.fillingInstruction
        const situation = res.data.data.situation
        const formConfig = res.data.data.formConfig
        const uploadMaterial = res.data.data.uploadMaterial
        const pickupMethod = res.data.data.pickupMethod
        const inforMationConfirmed = res.data.data.inforMationConfirmed
        sessionStorage.setItem(
          iid + '_fill',
          JSON.stringify({
            userAgreeMentName: res.data.data.userAgreeMentName,
            userAgreementContent: res.data.data.userAgreementContent
          })
        )
        let total = 0
        if (fillingInstruction === 'on') {
          total++
        }
        if (situation === 'on') {
          total++
        }
        if (formConfig === 'on') {
          total++
        }
        if (uploadMaterial === 'on') {
          total++
        }
        if (pickupMethod === 'on') {
          total++
        }
        if (inforMationConfirmed === 'on') {
          total++
        }
        const handleType = this.handleType === 'item' ? 'item' : 'onething'
        if (fillingInstruction === 'on') {
          const url = this.$router.resolve({
            path: '/fillInstruction',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.selectType
            }
          })
          window.open(url.href, '_blank')
        } else if (situation === 'on') {
          const url = this.$router.resolve({
            path: '/selectSitution',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.selectType
            }
          })
          window.open(url.href, '_blank')
        } else if (formConfig === 'on') {
          const url = this.$router.resolve({
            path: '/matterForm',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.selectType
            }
          })
          window.open(url.href, '_blank')
        } else if (uploadMaterial === 'on') {
          const url = this.$router.resolve({
            path: '/uploadMaterial',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.selectType
            }
          })
          window.open(url.href, '_blank')
        } else if (pickupMethod === 'on') {
          const url = this.$router.resolve({
            path: '/receiveInfo',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.selectType
            }
          })
          window.open(url.href, '_blank')
        } else if (inforMationConfirmed === 'on') {
          const url = this.$router.resolve({
            path: '/confirmInfo',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType
            }
          })
          window.open(url.href, '_blank')
        }
      })
    },
    // 继续编辑
    refill () {
      const that = this
      this.setSessionData()
      jiopWebAPI.findReportConfigByIid({ itemid: this.itemId }).then(res => {
        let total = 0
        const fillingInstruction = res.data.data.fillingInstruction
        const situation = res.data.data.situation
        const formConfig = res.data.data.formConfig
        const uploadMaterial = res.data.data.uploadMaterial
        const pickupMethod = res.data.data.pickupMethod
        const inforMationConfirmed = res.data.data.inforMationConfirmed
        const intelligentApproval = res.data.data.intelligentApproval ? res.data.data.intelligentApproval : 'off'
        const acceptFlowId = res.data.data.acceptFlowId
        const wholeIntelligentApproval = res.data.data.wholeIntelligentApproval ? res.data.data.wholeIntelligentApproval : 'off'
        const stepList = []
        if (fillingInstruction === 'on') {
          total++
          stepList.push({ name: 'fillInstruction', isOpen: false })
        }
        if (situation === 'on') {
          total++
          stepList.push({ name: 'selectSitution', isOpen: false })
        }
        if (formConfig === 'on') {
          total++
          stepList.push({ name: 'matterForm', isOpen: false })
        }
        if (uploadMaterial === 'on') {
          total++
          stepList.push({ name: 'uploadMaterial', isOpen: false })
        }
        if (pickupMethod === 'on') {
          total++
          stepList.push({ name: 'receiveInfo', isOpen: false })
        }
        if (inforMationConfirmed === 'on') {
          total++
          stepList.push({ name: 'confirmInfo', isOpen: false })
        }
        const stepNo = that.handling.steps
        const router = '/' + stepList[stepNo].name
        const handleType = this.handleType === 'item' ? 'item' : 'onething'
        that.$router.push({
          path: router,
          query: {
            itemId: that.itemId,
            stepNo: stepNo,
            total: total,
            flagTag: '0',
            flowId: res.data.data.flowId,
            handleType: handleType,
            materialList: JSON.stringify(that.materialList),
            intelligentApproval: intelligentApproval,
            acceptFlowId: acceptFlowId,
            wholeIntelligentApproval: wholeIntelligentApproval
          }
        })
      })
    }
  },
  created () {
    this.getGroupList(this.districtId)
    jiopWebAPI.itemThemeList({ serviceObj: 'personal', districtId: this.$route.query.areaCode || sessionStorage.getItem('districtId') }).then(res => {
      this.matterList = (res.data.itemType.itemType || [])
        .map(({ name, dictionaryCode: iid }) => ({
          name,
          iid
        }))
        .filter(({ iid }) => ['01', '05', '07', '08', '09', '10'].includes(iid))

      console.log(this.menuList, this.matterList, 'menuList')
      console.log(this.groupList, 'this.groupList')
    })
  }
}
</script>

<style lang="less" scoped>
.banner {
  height: 200px;
  background-image: url('../../assets/jiopweb/banner1.png');
  background-size: cover;
  background-position: center center;
  margin-bottom: 30px;
  div {
    width: 1200px;
    line-height: 200px;
    margin: auto;
    font-size: 40px;
    color: #fff;
    font-weight: 600;
  }
}
.layout {
  width: 1200px;
  height: 760px;
  display: flex;
  margin: auto;
  margin-bottom: 30px;
  .sider {
    flex-shrink: 0;
    width: 240px;
    box-shadow: 0px 2px 15px 0px rgba(153, 153, 153, 0.2);
    margin-right: 30px;
    display: flex;
    flex-direction: column;
    .line {
      height: 3px;
      background-color: #4493f5;
    }
    .tabs {
      display: flex;
      div {
        flex: 1;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        color: #999;
        font-weight: 600;
        img {
          width: 20px;
          margin-right: 11px;
        }
      }
      .selected {
        background-color: #d8e9ff;
        color: #4493f5;
      }
    }
    .menu {
      padding: 0 26px;
      div {
        line-height: 60px;
        border-top: 1px solid #eee;
        font-size: 18px;
        color: #333;
        text-align: center;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .menu:first-child div {
      border: none;
    }
    .menu:hover,
    .selected {
      background-color: #d8e9ff;
      div {
        color: #4493f5;
      }
    }
  }
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    > div {
      flex-shrink: 0;
    }
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      color: #666;
      font-weight: 400;
      margin-bottom: 16px;
    }
    .header {
      height: 55px;
      background-color: #f1f2f3;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      color: #333;
      font-weight: 600;
      margin-bottom: 4px;
      .name {
        flex: 1;
        padding-left: 31px;
      }
      .action {
        width: 113px;
      }
    }
    .list_item {
      border-bottom: 1px solid rgba(215, 216, 217, 0.5);
      .col {
        padding: 15px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          flex: 1;
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #333;
          font-weight: 400;
          > span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 600px;
          }
          .icon {
            width: 3px;
            height: 3px;
            border-radius: 50%;
            margin: 0 16px;
            background-color: #333;
          }
          .button {
            margin-left: 6px;
            height: 28px;
            padding: 0 12px;
            background-color: #f1f2f3;
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #2b2f32;
            font-weight: 400;
            cursor: pointer;
            img {
              margin-left: 12px;
              width: 12px;
            }
          }
        }
        .right {
          width: 113px;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            width: 80px;
            line-height: 30px;
            background-color: #ebf2fc;
            border: 1px solid #a9cfff;
            font-size: 14px;
            color: #4393f5;
            font-weight: 400;
            text-align: center;
            cursor: pointer;
          }
          .disabled {
            background-color: unset;
            border: 1px solid #888;
            color: #888;
            cursor: not-allowed;
          }
        }
      }
      .col1 {
        padding: 10px 0;
        .left {
          font-size: 14px;
        }
      }
      .col2 .left > span {
        color: #4393f5;
        cursor: pointer;
      }
      .col2:hover {
        background-color: #f1f2f3;
      }
    }
    ::v-deep .ant-table-pagination.ant-pagination {
      display: none;
    }
    .ant-pagination {
      display: flex;
      justify-content: center;
      margin-top: 30px;
    }
  }
}
</style>
